module.exports = __webpack_public_path__ + "img/weth.265128aa.svg";